import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import { connect } from 'react-redux';
import { shipmentsBySubstance } from 'selectors/generic';
import theme from 'source/theme';

const columnsBase = [
  { title: 'Codigo MP', field: 'mixture_code' },
  { title: 'MP', field: 'mixture_name' },
  { title: 'Codigo Fornecimento', field: 'shipment_code' },
  { title: 'Designação comercial', field: 'trade_name' },
  { title: 'Papel Reach', field: 'reach_role' },
  { title: 'Codigo Fornecedor', field: 'code' },
  { title: 'Nome', field: 'name' },
  {
    title: 'Ativo',
    field: 'active',
    render: value =>
      <span style={{ fontWeight: value ? 'bold' : null }}>
        {value ? 'Sim' : 'Não'}
      </span>
  }
];

const Component = props => {
  const {
    columns = columnsBase, shipmentsOfSubstance, suppliersById, rawMaterialsById, rowData, title
  } = props;

  // The raw material's own shipments, then those of every mixture it is part
  // of - `rowData.raw_material_suppliers` followed by a loop over
  // `rowData.mixtures`, which is what the index already holds in that order.
  // A shipment that arrived through a mixture is the one whose raw material is
  // not this row.
  const shipments = (shipmentsOfSubstance[rowData.id] || []).map(({ rawMaterialId, shipment }) => {
    const row = {
      ...shipment.supplier_id ? suppliersById[shipment.supplier_id] : [],
      trade_name: shipment.trade_name,
      reach_role: shipment.reach_role,
      shipment_code: shipment.code
    };

    if (rawMaterialId === rowData.id) {
      return row;
    }

    const mixture = rawMaterialsById[rawMaterialId];
    return { ...row, mixture_code: mixture.code, mixture_name: mixture.name };
  });

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable columns={columns} rows={shipments} title={title}/>
    </div>
  );
};

const mapStateToProps = state => ({
  shipmentsOfSubstance: shipmentsBySubstance(state)
});

export default connect(mapStateToProps)(Component);
